import JobList from "./JobList";
import TopNav from "../TopNav/TopNav";
import Home from "./Home";
import { useAuth } from '../../contexts/AuthContext';

function JobListContainer() {
  const { isAuthenticated } = useAuth();

  // Keep cached dropdown and critical data intact to avoid empty dropdowns
  // when navigating from Job List to Job Detail routes.

  return (
    <div>
      <TopNav />
      {!isAuthenticated && <Home />}
      {isAuthenticated && <JobList />}
    </div>
  );
}

export default JobListContainer;
